package com.dwarshb.bms

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowForward
import androidx.compose.material.icons.automirrored.filled.List
import androidx.compose.material.icons.automirrored.filled.ViewList
import androidx.compose.material.icons.filled.Close
import androidx.compose.material.icons.filled.ContentCopy
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonColors
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Tab
import androidx.compose.material3.TabRow
import androidx.compose.material3.Text
import androidx.compose.material3.TextField
import androidx.compose.material3.pulltorefresh.PullToRefreshDefaults
import androidx.compose.material3.pulltorefresh.pullToRefresh
import androidx.compose.material3.pulltorefresh.rememberPullToRefreshState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateMapOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.runtime.toMutableStateList
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerEventType
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.platform.LocalClipboardManager
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import busmanagementsystem.composeapp.generated.resources.Res
import busmanagementsystem.composeapp.generated.resources.available
import busmanagementsystem.composeapp.generated.resources.delete
import busmanagementsystem.composeapp.generated.resources.delete_trip_confirmation
import busmanagementsystem.composeapp.generated.resources.no
import busmanagementsystem.composeapp.generated.resources.passenger_list
import busmanagementsystem.composeapp.generated.resources.reserved
import busmanagementsystem.composeapp.generated.resources.seat_layout
import busmanagementsystem.composeapp.generated.resources.seat_variable
import busmanagementsystem.composeapp.generated.resources.ticket_details
import busmanagementsystem.composeapp.generated.resources.total
import busmanagementsystem.composeapp.generated.resources.view
import busmanagementsystem.composeapp.generated.resources.yes
import com.dwarshb.firebase.onCompletion
import com.mohamedrejeb.calf.ui.sheet.AdaptiveBottomSheet
import com.mohamedrejeb.calf.ui.sheet.rememberAdaptiveSheetState
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.stringResource

@OptIn(ExperimentalMaterial3Api::class, ExperimentalLayoutApi::class)
@Composable
fun TripDashboardScreen(trip: Trip, viewModel: TripViewModel = TripViewModel(),onBack : ()->Unit) {
    var selectedTab by remember { mutableStateOf(0) }
    var reservedSeats = remember { mutableStateMapOf<String,String>() }
    val bookings by viewModel.bookings.collectAsState()
    val clipboardManager = LocalClipboardManager.current

    var showBottomSheet by remember { mutableStateOf(false) }
    var bottomSheetAction by remember { mutableStateOf("View") }
    var selectedBooking by remember { mutableStateOf<Booking?>(null) }

    val coroutineScope = rememberCoroutineScope()
    var refreshing by remember { mutableStateOf(false) }
    val refreshState = rememberPullToRefreshState()
    val _onRefresh : () -> Unit = {
        refreshing = true
        viewModel.getReservations(trip.id)
        coroutineScope.launch {
            delay(3500)
            refreshing = false
        }
    }
    LaunchedEffect(trip.id) {
        viewModel.getReservations(trip.id)
    }
    LaunchedEffect(bookings) {
        reservedSeats.clear()
        bookings.forEach { (_, booking) ->
            reservedSeats.putAll(
                booking.selectedSeats.zip(booking.passengerDetails)
            )
        }
    }
    Column {
        AppIconTopBar {
            onBack()
        }

        Spacer(modifier = Modifier.height(24.dp))
        Column(
            modifier = Modifier.fillMaxWidth().background(
                Brush.verticalGradient(
                    ThemeColor.blueGradientBackground
                )
            )
        ) {
            Row(
                modifier = Modifier.padding(16.dp).fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(
                    trip.tripName,
                    color = Color.White,
                    fontWeight = FontWeight.Bold,
                    fontSize = 24.sp
                )
                Row(verticalAlignment = Alignment.CenterVertically,) {
                    Text(trip.id, color = Color.White)
                    IconButton(onClick = {
                        clipboardManager.setText(AnnotatedString(trip.id))
                    }) {
                        Icon(
                            Icons.Default.ContentCopy,
                            tint = Color.White,
                            contentDescription = null
                        )
                    }
                }
            }
            Row(
                Modifier.fillMaxWidth().padding(16.dp),
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Column {
                    Text(
                        trip.departureLocation,
                        color = Color.White,
                        fontWeight = FontWeight.Bold,
                        fontSize = 24.sp
                    )
                    Text(trip.departureDate, color = Color.White, fontSize = 12.sp)
                }
                Icon(
                    Icons.AutoMirrored.Default.ArrowForward,
                    tint = Color.White,
                    contentDescription = null
                )
                Column(horizontalAlignment = Alignment.End) {
                    Text(
                        trip.arrivalLocation,
                        color = Color.White,
                        fontWeight = FontWeight.Bold,
                        fontSize = 24.sp
                    )
                    Text(trip.arrivalDate, color = Color.White, fontSize = 12.sp)
                }
            }
            Card(
                modifier = Modifier.padding(16.dp),
                shape = RoundedCornerShape(16.dp)
            ) {
                FlowRow(
                    Modifier.fillMaxWidth().padding(16.dp),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalArrangement = Arrangement.spacedBy(24.dp)
                ) {
                    Column {
                        Text(
                            stringResource(Res.string.seat_variable,trip.totalSeats - reservedSeats.size),
                            modifier = Modifier.align(Alignment.CenterHorizontally),
                            fontWeight = FontWeight.Black
                        )
                        Text(stringResource(Res.string.available))
                    }
                    Column {
                        Text(
                            stringResource(Res.string.seat_variable,reservedSeats.size),
                            modifier = Modifier.align(Alignment.CenterHorizontally),
                            fontWeight = FontWeight.Black
                        )
                        Text(stringResource(Res.string.reserved))
                    }
                    Column {
                        Text(stringResource(Res.string.seat_variable,trip.totalSeats),
                            modifier = Modifier.align(Alignment.CenterHorizontally),
                            fontWeight = FontWeight.Black
                        )
                        Text(stringResource(Res.string.total))
                    }
                }
            }
        }
        var titles = listOf(
            stringResource(Res.string.passenger_list))
        if (trip.coachType!="Sleeper") {
            titles.toMutableList().add(stringResource(Res.string.seat_layout))
        }
        TabRow(
            selectedTabIndex = selectedTab
        ) {
            titles.forEachIndexed { index, s ->
                Tab(
                    selected = selectedTab == index,
                    onClick = { selectedTab = index },
                    text = { Text(s) }
                )
            }
        }


        if (bookings.size==0) {
            Column(modifier = Modifier.align(Alignment.CenterHorizontally).fillMaxHeight(),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center) {
                Icon(Icons.AutoMirrored.Default.ViewList,"")
                Text("No Bookings", style = MaterialTheme.typography.bodyMedium)
            }
        } else {
            if (selectedTab == 0) {
                Column(
                    modifier = Modifier.fillMaxWidth().verticalScroll(rememberScrollState())
                        .pullToRefresh(
                            isRefreshing = refreshing,
                            state = refreshState,
                            onRefresh = { _onRefresh() },
                            threshold = PullToRefreshDefaults.PositionalThreshold
                        ).pointerInput(Unit) {
                            awaitPointerEventScope {
                                while (true) {
                                    val event = awaitPointerEvent()
                                    val position = event.changes.first().scrollDelta.y
                                    // on every relayout Compose will send synthetic Move event,
                                    // so we skip it to avoid event spam
                                    if (event.type == PointerEventType.Scroll) {
                                        println(position)
                                        if (event.changes.first().scrollDelta.y < 0) {
                                            _onRefresh()
                                        }
                                    }
                                }
                            }
                        },
                ) {
                    PullToRefreshDefaults.Indicator(
                        modifier = Modifier.align(Alignment.CenterHorizontally),
                        state = refreshState, isRefreshing = refreshing
                    )
                    bookings.forEach {
//                        reservedSeats.putAll(it.value.selectedSeats.zip(it.value.passengerDetails))
                        Card(
                            modifier = Modifier.padding(8.dp).align(Alignment.CenterHorizontally),
                            elevation = CardDefaults.cardElevation(4.dp)
                        ) {
                            Column(Modifier.padding(16.dp)) {
                                it.value.passengerDetails.forEachIndexed { index, s ->
                                    TextField(
                                        value = s,
                                        onValueChange = {},
                                        readOnly = true,
                                        leadingIcon = {
                                            Text(
                                                it.value.selectedSeats[index],
                                                fontWeight = FontWeight.Bold,
                                                modifier = Modifier
                                                    .padding(8.dp)
                                                    .border(1.dp, Color.Black)
                                                    .padding(8.dp)
                                            )
                                        }
                                    )
                                }
                                Spacer(modifier = Modifier.height(16.dp))
                                FlowRow(
                                    modifier = Modifier.align(Alignment.CenterHorizontally),
                                    verticalArrangement = Arrangement.Center,
                                    horizontalArrangement = Arrangement.spacedBy(16.dp)
                                ) {
                                    Button(
                                        onClick = {
                                            selectedBooking = it.value
                                            showBottomSheet = true
                                            bottomSheetAction = "View"
                                        },
                                    ) {
                                        Text(stringResource(Res.string.view))
                                    }
                                    Button(
                                        colors = ButtonDefaults
                                            .buttonColors(containerColor = Color.Red),
                                        onClick = {
                                            selectedBooking = it.value
                                            showBottomSheet = true
                                            bottomSheetAction = "Delete"
                                        },
                                    ) {
                                        Text(stringResource(Res.string.delete), color = Color.White)
                                    }
                                }
                            }
                        }
                    }
                }
            } else {
                val seats = List(trip.totalSeats + 1) { index ->
                    val seatNumber = index.toString()
                    val reservedBy = reservedSeats[seatNumber]
                    BusSeat(seatNumber, trip.coachType, isBooked = reservedBy != null)
                }
                SeatLayout(seats = seats,
                    hideAvailableSeatsText = true,
                    hideConfirmButton = true,
                    coachType = trip.coachType,
                    selectedSeats = emptyList(),
                    leftSeats = trip.busLayout?.leftRow ?: 2,
                    rightSeats = trip.busLayout?.rightRow ?: 2,
                    backSeats = trip.busLayout?.backRow ?: 2,
                    onSeatSelected = {}
                )
            }
        }
        if (showBottomSheet==true) {
            selectedBooking?.let { PassengerDetailsBottomSheet(bottomSheetAction,trip, it,
                onDeleteReservation = {
                    showBottomSheet = false
                    viewModel.deleteReservation(it)
                }) {
                showBottomSheet = false
            } }
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun PassengerDetailsBottomSheet(action: String, trip: Trip,booking: Booking,
                                onDeleteReservation: (Booking) -> Unit,
                                onBack: () -> Unit) {
    var adaptiveSheetState = rememberAdaptiveSheetState()

    AdaptiveBottomSheet(
        onDismissRequest = {
            onBack()
        },
        adaptiveSheetState = adaptiveSheetState
    ){
        if (action=="View") {
            Row(
                modifier = Modifier.fillMaxWidth().padding(16.dp),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceEvenly
            ) {
                Text(
                    stringResource(Res.string.ticket_details),
                    style = MaterialTheme.typography.titleLarge,
                    modifier = Modifier.weight(1f).padding(start = 16.dp)
                )
                IconButton(onClick = { onBack() }) {
                    Icon(Icons.Default.Close, "")
                }
            }
        } else {
            Text(
                stringResource(Res.string.delete_trip_confirmation),
                modifier = Modifier.padding(16.dp),
                style = MaterialTheme.typography.titleLarge)
            Row(
                modifier = Modifier.align(Alignment.CenterHorizontally).padding(16.dp),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                Button(onClick = {onDeleteReservation(booking)},
                    colors = ButtonDefaults.buttonColors(containerColor = Color.Green)) {
                    Text(stringResource(Res.string.yes), color = Color.Black)
                }
                Button(onClick = {onBack()},
                    colors = ButtonDefaults.buttonColors(containerColor = Color.Red)) {
                    Text(stringResource(Res.string.no), color = Color.White)
                }
            }
        }
        Spacer(modifier = Modifier.height(16.dp))
        TicketCard(trip, booking)
    }
}